"use client";

import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { Button, Input } from "antd";
import { useRouter } from "next/navigation";
import { signIn } from "next-auth/react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";

type LoginValues = { username: string; password: string };

export const LoginForm = () => {
    const router = useRouter();
    const {
        handleSubmit,
        control,
    } = useForm<LoginValues>({ defaultValues: { username: "", password: "" } });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);

    const onLogin = async (data: LoginValues) => {
        setError(false);
        setLoading(true);
        const { username, password } = data;
        const result = await signIn("credentials", {
            redirect: false,
            username: username,
            password: password,
        });
        if (result?.ok) {
            // if (searchParams?.redirect) {
            //     router.push(searchParams.redirect);
            // } else {
            //     router.push(`/`);
            // }
            router.push(`/reports`);
        } else {
            setError(true);
            setLoading(false);
        }
    };

    // Надо изучть https://react-hook-form.com/get-started#IntegratingwithUIlibraries
    return (
        <form onSubmit={handleSubmit(onLogin)}>
            <div className="flex flex-col space-y-6">
                {/* <Button
                    loading={loading}
                    disabled={loading}
                    type="primary"
                    onClick={() => {
                        onLogin({ username: "ad", password: "ad" });
                    }}
                    className="bg-button"
                >
                    Войти как корпоративный пользователь
                </Button>
                <Divider>или</Divider> */}
                <div className="flex flex-col">
                    {/* <label>Username</label> */}
                    <Controller
                        name="username"
                        control={control}
                        render={({ field }) => (
                            <Input
                                prefix={<UserOutlined />}
                                {...field}
                                type="text"
                                autoFocus
                                autoComplete="username"
                                required
                                placeholder="Доменная учетная запись"
                            />
                        )}
                    />
                </div>
                <div className="flex flex-col">
                    {/* <label>Password</label> */}
                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                            <Input.Password
                                prefix={<LockOutlined />}
                                {...field}
                                autoComplete="password"
                                required
                                placeholder="Пароль"
                                // visibilityToggle={false}
                            />
                        )}
                    />
                </div>
                <Button loading={loading} disabled={loading} type="primary" htmlType="submit">
                    Войти по учетным данным
                </Button>
                {error && (
                    <div className="flex justify-center text-sm">
                        <div>Не удалось войти</div>
                    </div>
                )}
            </div>
        </form>
    );
};
